module.exports = __webpack_public_path__ + "img/salon1.7190bd3.png";